import React from "react";
import { POLICY_STATUS_CFG } from "./PolicyLifecyclePanel";

export const ACTION_LABELS = {
    "created":                  "Created",
    "submitted-for-review":     "Submitted for review",
    "reviewers-assigned":       "Reviewers assigned",
    "review-approved":          "Reviewer approved",
    "review-changes-requested": "Reviewer requested changes",
    "review-stalled":           "Review stalled",
    "approved":                 "Approved",
    "rejected":                 "Rejected",
    "published":                "Published",
    "reapproved":               "Re-approved",
    "version-effective":        "Version became effective",
    "archived":                 "Archived",
    "reverted":                 "Reverted to draft",
    "revised":                  "Revision started",
    "revision-discarded":       "Revision discarded",
    "in-force-expired":         "In-force version expired",
    "expiration-changed":       "Expiration extended",
    "owner-changed":            "Owner changed",
    "review-due":               "Review due",
    "re-uploaded":              "New version uploaded",
    "deleted":                  "Deleted",
    "attested":                 "Attested",
    "attestation-assigned":     "Attestation assigned",
    "attestation-cancelled":    "Attestation cancelled",
    "evidence-added":           "Evidence attached",
    "evidence-removed":         "Evidence removed",
    "mapping-added":            "Mapping added",
    "mapping-removed":          "Mapping removed",
    "requirement-added":        "Requirement added",
    "requirement-removed":      "Requirement removed",
    "exception-requested":      "Exception requested",
    "exception-approved":       "Exception approved",
    "exception-rejected":       "Exception rejected",
    "exception-revoked":        "Exception revoked",
    "exception-expired":        "Exception expired",
};

// Activity log (prototype tab 4): the org-wide append-only lifecycle audit feed.
const PolicyActivityLog = ({ events, titleById }) => {
    if (!events) return <p className="text-xs text-gray-400">Loading activity…</p>;
    if (events.length === 0) return <p className="text-xs text-gray-400">No policy activity recorded yet.</p>;

    return (
        <div className="bg-white border border-gray-200 rounded-xl divide-y divide-gray-100">
            {events.map(e => (
                <div key={e.id} className="px-4 py-2 flex items-center gap-2 text-xs flex-wrap">
                    <span className="font-medium text-gray-700">{ACTION_LABELS[e.action] || e.action}</span>
                    <span className="text-gray-500 truncate max-w-[220px]">{titleById?.(e.policyDocumentUploadId) || `Policy #${e.policyDocumentUploadId}`}</span>
                    {e.fromStatus && e.toStatus && e.fromStatus !== e.toStatus && (
                        <span className="text-gray-400">
                            {(POLICY_STATUS_CFG[e.fromStatus] || {}).label || e.fromStatus} → {(POLICY_STATUS_CFG[e.toStatus] || {}).label || e.toStatus}
                        </span>
                    )}
                    {e.performedByName
                        ? <span className="text-gray-500">by {e.performedByName}</span>
                        : <span className="text-gray-400 italic">system</span>}
                    {e.note && <span className="text-gray-400 truncate max-w-[320px]" title={e.note}>· {e.note}</span>}
                    <span className="text-gray-400 ml-auto flex-shrink-0">{new Date(e.createdAt).toLocaleString()}</span>
                </div>
            ))}
        </div>
    );
};

export default PolicyActivityLog;
